export const POLLING_INTERVAL_MS = 1000;

export const ERROR_CODES = {
  INVALID_CODE: 'INVALID_CODE',
  CODE_NOT_FOUND: 'CODE_NOT_FOUND',
  INVALID_DISPENSE_STATE: 'INVALID_DISPENSE_STATE',
  PICKUP_IN_ANOTHER_DEVICE: 'PICKUP_IN_ANOTHER_DEVICE',
};
